import { MutableRefObject, useEffect, useRef } from "react";

const useSwipeToTargetRef = (
  action: () => void,
  threshold = 0,
): MutableRefObject<HTMLDivElement | null> => {
  const targetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let touchStartY = 0;

    const handleTouchStart = (e: TouchEvent) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchEnd = (e: TouchEvent) => {
      const touchEndY = e.changedTouches[0].clientY;
      const touchDeltaY = touchEndY - touchStartY;

      if (touchDeltaY > threshold) {
        const touchEndElement = document.elementFromPoint(
          e.changedTouches[0].clientX,
          e.changedTouches[0].clientY,
        );
        if (targetRef.current && targetRef.current.contains(touchEndElement)) {
          action();
        }
      }
    };

    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [threshold, action]);

  return targetRef;
};

export default useSwipeToTargetRef;
